const mandatoryFields = ['quantity', 'price_in_cents'];

export default mandatoryFields;
